import { useCallback, useEffect, useState } from "react";
import { StringObject } from "../../types";
import { AC } from "../../utils/style";

type InputType = "transparent" | "time";

interface InputProps {
  variant?: InputType;
  placeholder?: string;
  type?: React.HTMLInputTypeAttribute;
  text?: string;
  className?: string;
  label?: string;
  onInput?: (value: string) => void;
}

const BASE_INPUT_STYLR = "focus:outline-none";

const DEFAULT_VARIANT: InputType = "time";
const DEFAULT_TYPE: React.HTMLInputTypeAttribute = "text";

const TYPOGRAPHY_STYLES: StringObject<string> = {
  transparent:
    "font-medium text-md text-text bg-transparent placeholder:text-sm placeholder:font-medium placeholder:text-text-placeholder",
  time: "p-3 font-medium text-md text-text bg-main-background border-main-gray border-[1px] rounded-lg placeholder:text-sm placeholder:font-medium placeholder:text-text-placeholder",
};

const Input = (props: InputProps) => {
  const [text, setText] = useState<string>(props.text || "");

  const style = TYPOGRAPHY_STYLES[props.variant || DEFAULT_VARIANT];
  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setText(event.currentTarget.value);
  }, []);

  useEffect(() => {
    if (props.onInput) props.onInput(text);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  return (
    <div className="flex flex-col">
      {props.label && <label className="font-bold mb-1">{props.label}</label>}
      <input
        placeholder={props.placeholder}
        type={props.type || DEFAULT_TYPE}
        className={AC(BASE_INPUT_STYLR, style, props.className)}
        onChange={onChange}
      />
    </div>
  );
};

export default Input;
